import { render, staticRenderFns } from "./StatusCadastros.vue?vue&type=template&id=0e063272&"
import script from "./StatusCadastros.vue?vue&type=script&lang=js&"
export * from "./StatusCadastros.vue?vue&type=script&lang=js&"
import style0 from "./StatusCadastros.vue?vue&type=style&index=0&id=0e063272&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports